<div id=timerContainer>
	<!-- MODE TOGGLE (timer is shown in encounters only) -->
	<div id=modeSwitch class="switch-vertical" class:inactive={!user.isMaster}
       onmousedown={start_longpress} onmouseup={clear_longpress}>
    <div class=toggle style="--selected: {toggleState}">
      <span></span>
    </div>
    <div class="labels">
      <input type=radio id=scoutMode data-help="modeSwitch" name=modeRadio value=recon disabled={!user.isMaster} onchange={switch_mode}/>
      <label for=scoutMode data-help="modeSwitch">Erkunden</label>
      <input type=radio id=combatMode data-help="modeSwitch" name=modeRadio value=combat disabled={!user.isMaster} onchange={switch_mode}/>
      <label for=combatMode data-help="modeSwitch">Kampf</label>
    </div>
	</div>

	<!-- PROCEED BUTTON -->
	{#if user.isMaster && game.mode !== 'story'}
    <img id=proceedBtn class="button icon masterOnly" class:unready={!game.occupied}
         src="/static/buttons/{proceedBtn}.png" alt="{proceedBtn}"
         onmousedown={proceed_game} onmouseup={clear_longpress} oncontextmenu={(e) => e.preventDefault()} />
	{/if}

	<!-- CLOCK FACE -->
	<div id=clock data-help="clock" class="button {game.mode}" class:running={game.mode.charAt(0) !== 's' && !game.halted}
       onclick={() => view.timelineShown = !view.timelineShown}>
    <div class=face>
      <span class="min">{min}</span>
      <span class="label label-mm">min</span>
    </div>
    <div class=face>
      <span class="sec">{sec.toString().padStart(2,"0")}</span>
      <span class="label label-ss">sec</span>
    </div>
	</div>
</div>


<script>
    import { user, game, view, send_request} from "../client.svelte.js";
    import {timestamp} from "../core.js";

		/// component state variables
    let proceedBtn = $derived.by(() => {
	    if (game.halted)
		    setTimeout(() => running = false, 1000)
	    return (game.mode === 'stop') ? ((game.scriptEnd > game.time) ? 'script' : 'contin') :
		    (!game.halted) ? 'halt' : game.mode
    })
    let toggleState = $derived(proceedModes.find(mode => mode.name === game.mode)?.toggle ?? 0)
    let min = $derived(Math.floor(game.time/60))
    let sec = $derived(game.time - min * 60)
    let running = false
    const proceedModes = [{name: 'script', label: "Skript", toggle: 0},
                          {name: 'recon', label: "Erkundung", toggle: 1},
                          {name: 'combat', label: "Kampf", toggle: 2},
                          {name: 'contin', label: "Realtime", toggle: 2}]
    // $inspect(`TIMER - proceedBtn`, proceedBtn)


		/**** Time controls *****/

    let stopDelay = null, fastDelay = null   // is integer (TimerID) when in delay phase

    function proceed_game(e) {
				// do not proceed game if it is currently halting (= server has halted within the last second)
				if (e.button === 0 && running && proceedBtn === 'combat')
						return
				if (e.button === 2) {
						fastDelay = setTimeout(fast_replay, 1000)
						running = true
				}
        const mode = (e.button === 0 && !running) ? 'step' :
	                   (['recon', 'combat'].includes(proceedBtn)) ? 'auto' : proceedBtn
        // console.log(`TIMER: Master proceeds fight (${mode}) in mode ${proceedBtn} from ${timestamp(game.time)}`)
        send_request('proceed', {mode: mode}, `Master proceeds fight (${mode}) in mode ${proceedBtn} at ${timestamp(game.time)}`)
		}

    function switch_mode(e) {
        const mode = e.target.value	    // use Timer variable set by toggle box
        if (!user.isMaster || mode === game.mode)  return
        console.log(`TIMER: Master changes mode to ${mode}`)
        send_request('control', {command: 'MODE', mode: mode})
		}


    function stop_game() {
        clear_longpress()
        console.log(`TIMER: Master stops scene at ${timestamp(game.time)}`)
        send_request('proceed', {mode: 'stop'})
		}


    function fast_replay() {
        clear_longpress()
        console.log(`TIMER: Master switches replay to fast`)
		}

    function start_longpress(e) {
        if (e.button === 2 && e.currentTarget.id === 'modeSwitch') {
            stopDelay = setTimeout(stop_game, 1000)
        } else if (e.button === 0 && e.currentTarget.id === 'proceedBtn')
            fastDelay = setTimeout(fast_replay, 1000)
		}

    function clear_longpress() {
        if (stopDelay) {
            clearTimeout(stopDelay)
            stopDelay = null
        }
        if (fastDelay) {
            clearTimeout(fastDelay)
            fastDelay = null
        }
		}
</script>


<style lang="sass">
	@use "../colors" as colors

	/* right end of the play header (Breadcrumbs bar for the master) */
	#timerContainer
		flex: none
		box-sizing: border-box
		width: 240px
		height: 100%
		padding: 0 10px
		display: flex
		align-items: center
		justify-content: space-between
		background-color: #111111

	:global(.master #timerContainer)
		width: 300px

	#clock
		height: auto

	/* Very nice counter animation: http://fff.cmiscm.com/#!/section/flipclock*/
	#clock .face
		display: inline-block
		vertical-align: top
		position: relative
		font-family: 'Open Sans', 'Lucida Console', Monospaced, serif
		font-weight: 300
		font-size: 2em
		line-height: 1.5em
		text-align: center
		color: #B0B0B0
		border-radius: 10px
		padding: 0.2em
		background: linear-gradient(#202020, #404040, #202020)
		overflow: hidden

	#clock .face:after
		content: ''
		display: block
		height: 1px
		border-top: 1px solid #111
		width: 100%
		position: absolute
		top: 45%
		left: 0

	#clock .label
		text-transform: uppercase
		display: block
		position: absolute
		font-family: 'Open Sans', cursive
		font-weight: 700
		line-height: normal
		right: 6px
		bottom: 4px
		font-size: 8px
		color: #B9B9B9

	#clock.stop div
		background: #550000

	#clock.script div
		background: #544d00

	#clock.running div
		background: #000055

	#proceedBtn.unready
		filter: saturate(0)

	.proceedModeSelection
		position: absolute
		background: black
		left: -24px
		top: 80px
		width: 380px
		display: flex
		justify-content: space-between

	#modeSwitch
		position: relative
		width: 96px
		height: 54px     /* fixed width causes better optical spacing of elements */
		display: flex
		column-gap: 12px

	#modeSwitch.inactive
		pointer-events: none

	#modeSwitch input
		position: absolute
		left: 0
		top: 0
		width: 24px
		height: 100%
		z-index: 2
		opacity: 0
		cursor: pointer

	#modeSwitch input:checked
		z-index: 1

	#modeSwitch .labels
		width: 76px

	#modeSwitch label
		color: colors.$white
		opacity: 0.33
		cursor: pointer
		transition: opacity 0.3s ease-in-out
		font-size: 15px
		line-height: 28px

	#modeSwitch input:checked + label
		opacity: 1
		color: colors.$white
		cursor: default

	#modeSwitch input:not(:checked) + label:hover
		opacity: 0.5

	.toggle
		position: relative
		width: 23px
		height: 100%
		background: rgba(255, 255, 255, 0.5)
		border-radius: 17px
		padding: 11px
		overflow: hidden
		transition: opacity 0.3s ease-in-out

	.toggle span
		position: absolute
		left: 3px
		top: calc(-24px + var(--selected) * 28px)
		width: 17px
		height: 17px
		border-radius: 50%
		background: #424242
		transition: all 0.3s ease-in-out

</style>